import "./form/style";
// import './style/font';
import App from "./form/components/app";
import _en from "../locale/en";
import { i18nUtils as i18n } from "./utils/i18n";

i18n.load(_en);

export default App;



// WEBPACK FOOTER //
// ./index.form.js